export default __webpack_public_path__ + "static/media/icon-check.b0c4b24d.svg";